class footerJs {
  constructor() {
    this.init();
  }

  accordionFooter() {
    const footerAccordions = document.querySelectorAll('.toggle-footer-menu');
    footerAccordions.forEach((menuIcon)=>{
      menuIcon.addEventListener('click', (e)=>{
        const parentElement = e.target.closest('.footer_dropdown');
        if(parentElement.classList.contains('open')){
          Utility.toggleElement(parentElement, 'close');
        }else{
          Utility.toggleElement(parentElement, 'open');
        }
      });
    });
  }

  changeGeoLocation() {

    var formsGeo = document.querySelector('.geo-location-form');
    if (formsGeo != null) {
      if (window.innerWidth > 991) {
        var deskForm = formsGeo.outerHTML;
        document.querySelector('#desktopGeoLocation').innerHTML = deskForm;
        formsGeo = document.querySelector('.geo-location-form');
      }
      var select = formsGeo.querySelector('select');
      if (select != null) {
        select.addEventListener('change', function(){
          formsGeo.submit();
        })
      }
    }
  }

  init() {
    if (window.innerWidth <= 991) {
      this.accordionFooter();
    }
    this.changeGeoLocation();
  }
}
new footerJs;